import { render } from "./CustomFieldsTab.vue?vue&type=template&id=0fcbee4c&scoped=true"
import script from "./CustomFieldsTab.vue?vue&type=script&lang=js"
export * from "./CustomFieldsTab.vue?vue&type=script&lang=js"

import "./CustomFieldsTab.vue?vue&type=style&index=0&id=0fcbee4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcbee4c"]])

export default __exports__